import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c119c338"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contractid" }
const _hoisted_2 = {
  key: 0,
  class: "bg-white px-6 py-4 border flex flex-col justify-center items-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Загрузка...", -1))
const _hoisted_4 = { class: "contractid__header" }
const _hoisted_5 = { class: "contractid__container" }
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-2 gap-3"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "ID", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Дата договора", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Номер договора в реестре", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Подразделение", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Компания", -1))
const _hoisted_12 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "БИН", -1))
const _hoisted_14 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Инициатор", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Дата добавления записи", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Кто добавил запись", -1))
const _hoisted_18 = { class: "mt-5 flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_loader, { class: "mt-1 primary" })
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_page_title, {
              title: `Договор № ${_ctx.state.contract.number}`
            }, null, 8, ["title"]),
            _createVNode(_component_the_button, {
              class: "primary text small",
              onClick: _ctx.goRegister
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Перейти к реестру ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_page_title, {
              class: "mb-4",
              title: "Общая информация"
            }),
            (_ctx.state.contract)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_the_input, {
                    value: _ctx.state.id,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.id) = $event)),
                    disabled: ""
                  }, null, 8, ["value"]),
                  _hoisted_8,
                  _createVNode(_component_the_input, {
                    value: _ctx.state.date,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.date) = $event)),
                    "is-invalid": _ctx.state_form$.date.$error,
                    "validation-errors": _ctx.state_form$.date.$errors,
                    type: "date"
                  }, null, 8, ["value", "is-invalid", "validation-errors"]),
                  _hoisted_9,
                  _createVNode(_component_the_input, {
                    value: _ctx.state.number,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.number) = $event)),
                    "is-invalid": _ctx.state_form$.number.$error,
                    "validation-errors": _ctx.state_form$.number.$errors
                  }, null, 8, ["value", "is-invalid", "validation-errors"]),
                  _hoisted_10,
                  _createVNode(_component_the_select, {
                    placeholder: "Подразделение",
                    loading: _ctx.data_state.subdivisions.is_loading,
                    failed: _ctx.data_state.subdivisions.is_failed,
                    "error-text": "При получении списка произошла ошибка",
                    options: _ctx.data_state.subdivisions.list,
                    "is-invalid": _ctx.state_form$.subdivisionId.$error,
                    "validation-errors": _ctx.state_form$.subdivisionId.$errors,
                    value: _ctx.state.subdivisionId,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.subdivisionId) = $event)),
                    onRefresh: _ctx.loadSubdivisions,
                    onChange: _ctx.onSubdivisionSelected
                  }, null, 8, ["loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh", "onChange"]),
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_checkbox, {
                      label: "Нет компании",
                      value: _ctx.state.is_not_company,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.is_not_company) = $event)),
                      disabled: _ctx.state.is_loading,
                      onChange: _ctx.onCheckboxChange
                    }, null, 8, ["value", "disabled", "onChange"]),
                    (_ctx.state.is_not_company)
                      ? (_openBlock(), _createBlock(_component_the_input, {
                          key: 0,
                          placeholder: "Компания",
                          "is-invalid": _ctx.state_form$.companyName.$error,
                          "validation-errors": _ctx.state_form$.companyName.$errors,
                          value: _ctx.state.companyName,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.companyName) = $event))
                        }, null, 8, ["is-invalid", "validation-errors", "value"]))
                      : (_openBlock(), _createBlock(_component_the_select, {
                          key: 1,
                          placeholder: "Компания",
                          loading: _ctx.data_state.companies.is_loading,
                          failed: _ctx.data_state.companies.is_failed,
                          "error-text": "При получении списка произошла ошибка",
                          options: _ctx.data_state.companies.list,
                          value: _ctx.state.companyId,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.companyId) = $event)),
                          "is-invalid": _ctx.state_form$.companyId.$error,
                          "validation-errors": _ctx.state_form$.companyId.$errors,
                          "infinite-scroll": "",
                          "search-without-refresh": "",
                          onRefresh: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
                          onLoadmore: _cache[8] || (_cache[8] = ($event: any) => (
                                _ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1)
                            )),
                          onSearch: _ctx.searchCompanies,
                          onOptionBySearch: _ctx.unshiftFindedCompany,
                          onChange: _ctx.onCompanySelected
                        }, null, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onSearch", "onOptionBySearch", "onChange"]))
                  ]),
                  _hoisted_13,
                  _createVNode(_component_the_input, {
                    value: _ctx.state.companyBin,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.companyBin) = $event)),
                    "is-invalid": _ctx.state_form$.companyBin.$error,
                    "validation-errors": _ctx.state_form$.companyBin.$errors
                  }, null, 8, ["value", "is-invalid", "validation-errors"]),
                  (_ctx.state.typeId)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Тип договора"))
                    : _createCommentVNode("", true),
                  (_ctx.state.typeId)
                    ? (_openBlock(), _createBlock(_component_the_select, {
                        key: 1,
                        placeholder: "Тип договора",
                        loading: _ctx.data_state.types.is_loading,
                        failed: _ctx.data_state.types.is_failed,
                        "error-text": "При получении списка произошла ошибка",
                        "is-invalid": _ctx.state_form$.typeId.$error,
                        "validation-errors": _ctx.state_form$.typeId.$errors,
                        options: _ctx.data_state.types.list,
                        value: _ctx.state.typeId,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.typeId) = $event)),
                        "infinite-scroll": "",
                        onRefresh: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadTypes(_ctx.data_state.types.pagination.current_page))),
                        onLoadmore: _cache[12] || (_cache[12] = ($event: any) => (_ctx.loadMoreTypes(_ctx.data_state.types.pagination.current_page + 1)))
                      }, null, 8, ["loading", "failed", "is-invalid", "validation-errors", "options", "value"]))
                    : _createCommentVNode("", true),
                  _hoisted_15,
                  _createVNode(_component_the_select, {
                    class: "mt-2",
                    value: _ctx.state.initiatorId,
                    "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.initiatorId) = $event)),
                    "is-invalid": _ctx.state_form$.initiatorId.$error,
                    "validation-errors": _ctx.state_form$.initiatorId.$errors,
                    placeholder: "Инициатор",
                    loading: _ctx.data_state.initiators.is_loading,
                    options: _ctx.data_state.initiators.list,
                    failed: _ctx.data_state.initiators.is_failed,
                    "error-text": "При получении списка произошла ошибка",
                    "infinite-scroll": "",
                    onRefresh: _cache[14] || (_cache[14] = ($event: any) => (_ctx.loadInitiators(_ctx.data_state.initiators.pagination.current_page))),
                    onLoadmore: _cache[15] || (_cache[15] = ($event: any) => (
                            _ctx.loadMoreInitiators(_ctx.data_state.initiators.pagination.current_page + 1)
                        )),
                    onSearch: _ctx.searchInitiators,
                    onOptionBySearch: _ctx.unshiftFindedInitiator,
                    onChange: _ctx.onInitiatorSelected
                  }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch", "onChange"]),
                  _hoisted_16,
                  _createVNode(_component_the_input, {
                    value: _ctx.state.createdAt,
                    "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.createdAt) = $event)),
                    type: "date"
                  }, null, 8, ["value"]),
                  _hoisted_17,
                  _createVNode(_component_the_input, {
                    value: _ctx.state.createdByEmail,
                    "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.createdByEmail) = $event))
                  }, null, 8, ["value"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_the_button, {
                class: "primary small",
                onClick: _ctx.editContract
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Сохранить ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ], 64))
  ]))
}